module.exports = __webpack_public_path__ + "media/video_3.d56bfd3a.mp4";